export const _3gpMimeTypes = ["audio/3gpp", "video/3gpp"];
